module.exports = __webpack_public_path__ + "img/close.6459849c.svg";